import { useState } from "react";
import { useLocation } from "react-router-dom";
import { BookOpenText, List, X, Sparkle } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

const LINKS = [
  { href: "/kids-corner", label: "Kids Corner", id: "kids-corner" },
  { href: "/resources", label: "For Grown-Ups", id: "resources" },
  { href: "/resources#show-dont-tell", label: "Show, Don't Tell", id: "sdt" },
  { href: "/resources#amazon", label: "Amazon Books", id: "amazon" },
  { href: "#free-tools", label: "Free Tools", id: "free-tools" },
  { href: "#course", label: "Course", id: "course" },
  { href: "#about", label: "About", id: "about" },
];

export const SiteNav = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const href = (h) => (h.startsWith("#") && pathname !== "/" ? `/${h}` : h);

  return (
    <header className="sticky top-0 z-50">
      <div className="bg-[#0f285f] text-white text-center px-4 py-2" data-testid="announcement-bar">
        <p className="font-nunito text-xs sm:text-sm font-semibold tracking-wide">
          A joyful place for children to learn—and a trusted resource for those who support them.
        </p>
      </div>
      <nav className="bg-white/90 backdrop-blur-md border-b border-[#d4dff0]" aria-label="Main navigation">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16 gap-3">
            <a href="/" className="flex items-center gap-2 min-w-0" data-testid="nav-logo" aria-label="Embrace the Magic of Words home">
              <BookOpenText size={30} weight="duotone" className="text-[#178478] shrink-0" />
              <span className="font-nunito font-extrabold tracking-tight text-base sm:text-xl text-[#17284b] truncate">
                Embrace the Magic of Words
              </span>
            </a>
            <div className="hidden lg:flex items-center gap-5">
              {LINKS.map((l) => (
                <a
                  key={l.id}
                  href={href(l.href)}
                  className="font-nunito font-semibold text-sm text-muted-foreground hover:text-[#17284b] transition-colors"
                  data-testid={`nav-${l.id}`}
                >
                  {l.label}
                </a>
              ))}
            </div>
            <div className="flex items-center gap-2">
              <a href="/kids-corner" data-testid="nav-enter-kids-btn" className="hidden sm:block">
                <Button className="bg-[#7358b3] hover:bg-[#5f479a] text-white font-nunito font-bold border border-[#d4dff0] rounded-full px-5">
                  <Sparkle size={18} weight="fill" className="mr-2" />
                  Enter Kids Corner
                </Button>
              </a>
              <button
                type="button"
                onClick={() => setOpen((o) => !o)}
                aria-expanded={open}
                aria-label={open ? "Close menu" : "Open menu"}
                className="lg:hidden w-11 h-11 flex items-center justify-center rounded-full border border-[#d4dff0] bg-white"
                data-testid="nav-menu-toggle"
              >
                {open ? <X size={22} weight="bold" /> : <List size={22} weight="bold" />}
              </button>
            </div>
          </div>
        </div>
        {open && (
          <div className="lg:hidden border-t border-[#d4dff0] bg-white" data-testid="nav-mobile-menu">
            <div className="max-w-7xl mx-auto px-4 py-4 flex flex-col gap-1">
              {LINKS.map((l) => (
                <a
                  key={l.id}
                  href={href(l.href)}
                  onClick={() => setOpen(false)}
                  className="font-nunito font-bold text-base text-[#17284b] py-3 px-3 rounded-xl hover:bg-muted"
                  data-testid={`nav-mobile-${l.id}`}
                >
                  {l.label}
                </a>
              ))}
              <a href="/kids-corner" onClick={() => setOpen(false)} data-testid="nav-mobile-enter-kids-btn" className="mt-2">
                <Button className="w-full bg-[#7358b3] hover:bg-[#5f479a] text-white font-nunito font-bold border border-[#d4dff0] rounded-full py-5">
                  <Sparkle size={18} weight="fill" className="mr-2" />
                  Enter Kids Corner
                </Button>
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};
